import {debounce} from 'throttle-debounce';

/**
 * map control base class move map
 */
export class MapControlBase {
  /**
   * instance of map
   */
  _map = null;

  /**
   * center of map
   */
  _centerMap;

  /**
   * move to location coordinates
   * @param {object} latitude, longitude
   */
  moveToLocation = ({latitude, longitude}) => {
    const center = new window.google.maps.LatLng(latitude, longitude);
    this._map.panTo(center);
  };

  get map() {
    return this._map;
  }

  /**
   * set zoom to map
   * @param {number} zoom of map
   */
  setZoom = zoom => this._map.setZoom(zoom);

  /**
   * get zoom of map
   */
  getZoom = () => this._map.getZoom();

  /**
   * set map instance in this _map
   *
   * @param {Map Google} instance of map
   */
  setMap = map => {
    this._map = map;
    this._centerMap = this._map.getCenter();
  };

  /**
   * execute cb when map move
   */
  listenMapMove = (cb = () => true, interval = 300) => {
    window.google.maps.event.addListener(
      this._map,
      'idle',
      debounce(interval, () => {
        this._centerMap = this._map.getCenter();
        cb(this._centerMap);
      }),
    );
  };

  /**
   * return center coodonates of map
   */
  getCenter = () => {
    if (this._centerMap) {
      return {
        latitude: this._centerMap.lat(),
        longitude: this._centerMap.lng(),
      };
    }
    return {
      latitude: null,
      longitude: null,
    };
  };
}

export default MapControlBase;
